export const shortenFileName = (fileName: string, maxLength = 10) => {
  if (fileName) {
    const dotIndex = fileName.lastIndexOf('.');
    const baseName = fileName.slice(0, dotIndex);
    const extension = fileName.slice(dotIndex);

    if (baseName.length > maxLength) {
      return baseName.slice(0, maxLength) + '...' + extension;
    }
  }

  return fileName;
};
